import * as React from 'react';
import CountryService from '../../services/CountryService';
import { Radio, CheckBox } from '../../components/FormGenerator/modules';
import { CurrencyFormatter as Currency } from '../../utils/utils';
import { findPrice } from '../../helpers/prices';
import { getDeliveryMethodPrices } from '../../helpers/deliveryMethods/getDeliveryMethodPrices';
import CartService from '../../services/CartService';
import { getInsuranceLimitByOrder } from '../../helpers/deliveryMethods/getInsuranceLimitByOrder';
import { getPriceWithoutVat } from 'data-layer/src/helpers/prices/getPriceWithoutVat';
import { vatDescription } from '../../helpers/vatDescription';

interface IDeliveryMethodsProps {
  fieldName: string;
  selected: any;
  selectedPaymentMethod?: GQL.IPaymentMethod;
  deliveryMethods: Array<GQL.IDeliveryMethod>;
  insuranceLimit: GQL.IDeliveryMethodInsuranceLimit | null;
  errorMessage?: string;
  onChange: (e: any) => void;
}

class DeliveryMethods extends React.Component<IDeliveryMethodsProps> {

  public componentWillReceiveProps(nextProps: IDeliveryMethodsProps) {
    const { deliveryMethods, selected, selectedPaymentMethod } = nextProps;
    // je vybrána doprava
    if (selected && selectedPaymentMethod) {
      const selectedDelivery = deliveryMethods.find((dm: GQL.IDeliveryMethod) => dm.id === selected);
      if (selectedDelivery) {
        // kontrola zda vybraná doprava je podporovaná platbou (systém je nastaven naopak!)
        const isDeliveryEnabled = selectedDelivery.paymentMethods.some((pm: GQL.IPaymentMethod) => pm.id === selectedPaymentMethod.id);
        if (!isDeliveryEnabled) {
          this.props.onChange(null);
        }
      }
    }
  }

  public render() {
    const { fieldName, selected, selectedPaymentMethod, insuranceLimit, errorMessage } = this.props;
    const { language, VATrate, countryCode } = CountryService.GetInstance();
    const { totalWeightForShipping, totalPrice } = CartService.GetInstance();

    return (
      <div className="delivery-methods">
        {errorMessage &&
          <p className={'form__error form__error--static'}>
            {errorMessage}
          </p>}
        <table className="table table--form">
          <tbody>
            {this.props.deliveryMethods &&
              this.props.deliveryMethods.map((deliveryMethod: GQL.IDeliveryMethod, i: number) => {

                const label =
                  <span>
                    {/* {hasImages &&
                      <div className="image">
                        <Image image={deliveryMethod.image} />
                      </div>} */}
                    {deliveryMethod.name[language]}
                    {deliveryMethod.description && deliveryMethod.description[language] &&
                      <React.Fragment>
                        <br />
                        <span className="description" dangerouslySetInnerHTML={{ __html: ('' + deliveryMethod.description[language]).replace(/\n/g, '<br>') }} />
                      </React.Fragment>}
                  </span>;

                const enabled = selectedPaymentMethod 
                  ? deliveryMethod.paymentMethods.some((pm: GQL.IPaymentMethod) => pm.id === selectedPaymentMethod.id)
                  : false;

                const deliveryInsuranceLimit = deliveryMethod.insurance && deliveryMethod.insuranceLimits &&
                  getInsuranceLimitByOrder(deliveryMethod.insuranceLimits, totalPrice, VATrate); // todo: total price in primary currency !!!!!

                // ceny dopravy, podle váhy
                const deliveryPrices = getDeliveryMethodPrices(deliveryMethod, totalWeightForShipping);

                // zjištění, zda není doprava kvůli váze blokována
                const deliveryDisabled = deliveryPrices
                  ? deliveryPrices
                      .reduce((acc: boolean, price: GQL.IDeliveryMethodPrice) => {
                        if (price && price !== undefined && price !== null && price.active === false) {
                          acc = true;
                        }
                        return acc;
                      }, false)
                  : false;
  
                // doprave kvuli váze ignorována
                if (deliveryDisabled) {
                  return null;
                }
  
                // konečná cena dopravy
                let deliveryPrice = findPrice(deliveryPrices, false, VATrate, deliveryMethod);
                // doprava zdarma
                if (CartService.GetInstance().isFreeDelivery(deliveryMethod.id)) {
                  deliveryPrice = 0;
                }

                return (
                  <tr key={i} className={`method${selected === deliveryMethod.id ? ' active' : ''}`}>
                    <td className="table__radio">
                      <Radio
                        fieldName={fieldName}
                        value={deliveryMethod.id}
                        checked={selected === deliveryMethod.id}
                        label={label}
                        readOnly={!enabled}
                        onChange={(e: any) => this.onChange(e)}
                      />

                      {deliveryInsuranceLimit && 
                        <div className="insurance__label">
                          <CheckBox
                            label={'Shipment insurance'}
                            checked={insuranceLimit !== null && selected === deliveryMethod.id}
                            readOnly={!enabled || !(selected === deliveryMethod.id)}
                            onChange={(e: any) => this.onChangeInsuranceLimit(e, deliveryInsuranceLimit)}
                          />
                        </div>}

                    </td>
                    <td className="table__price">
                      {deliveryMethod.unknownPrice === true &&
                        <span>{(deliveryMethod.unknownPriceLabel || {})[language]}</span>}
                      {deliveryMethod.unknownPrice !== true &&
                        <>
                         <Currency price={getPriceWithoutVat(deliveryPrice, VATrate)} decimals={2} />
                          {countryCode.toLowerCase() !== 'us' && VATrate > 0 && deliveryPrice > 0 &&
                            <>
                              <br />
                              <span className="withoutVat">
                                <Currency price={deliveryPrice} /> incl. {vatDescription()}
                              </span>
                            </>}
                        </>}
                      
                      {deliveryInsuranceLimit && 
                        <div className="insurance__price">
                          <Currency price={findPrice(deliveryInsuranceLimit.prices, false, VATrate)} />
                        </div>}
                    </td>
                  </tr>
                );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  private onChangeInsuranceLimit(e: any, deliveryInsuranceLimit: GQL.IDeliveryMethodInsuranceLimit) {
    const { checked } = e.target;

    this.onChange({ target: { name: 'deliveryInsurance', value: (checked === true ? deliveryInsuranceLimit : null) } });
  }

  private onChange(e: any) {
    const { name, value, checked } = e.target;

    if (name === 'deliveryInsurance') {
      this.props.onChange(e);
    }

    if (name === this.props.fieldName) {
      this.props.onChange({
        target: {
          name: this.props.fieldName,
          value: this.props.deliveryMethods.find((pm: GQL.IDeliveryMethod) => pm.id === e.target.value),
        }
      });
    }
  }
}

export default DeliveryMethods;


// WEBPACK FOOTER //
// ./src/components/DeliveryMethods/DeliveryMethods.tsx